<template>
  <b-modal
    id="forget-password-modal"
    ref="forget-password-modal"
    centered
    hide-header
    hide-footer
    modal-class="coop-modal"
    @hide="onModalHide"
  >
    <button
      type="button"
      class="modal-close-button"
      @click.prevent="closeModal"
    >
      <img src="~assets/images/close-button.svg">
    </button>
    <div class="modal-title-holder">
      <h1
        class="modal-title login-title"
      >
        FORGET<br>
        PASSWORD
      </h1>
      <p class="instruction">
        Don't worry. Resetting your password is easy.
        Just tell us the email address you register with
        C ASEAN SAMYAN CO-OP.
      </p>
    </div>
    <b-form @submit="onSubmit" @reset="onReset">
      <b-form-group
        id="forget-password-email"
        label="EMAIL"
        label-for="forget-password-email-input"
        label-class="modal-form-label"
      >
        <b-form-input
          id="forget-passwordogin-email-input"
          v-model="forgotPasswordForm.email"
          v-validate="'required|email'"
          name="forget-passwordogin-email-input"
          :state="validateState('forget-passwordogin-email-input')"
          type="email"
          required
          placeholder="Enter email"
        />
        <b-form-invalid-feedback
          v-if="$coopHelper.isClient()"
        >
          {{ veeErrors.first('forget-passwordogin-email-input') }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-button
        type="submit"
        variant="primary"
        class="button -block"
        @click="onResetPassword"
      >
        RESET PASSWORD
      </b-button>
      <br>
      <br>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  data () {
    return {
      forgotPasswordForm: {
        email: ''
      },
      errorMessages: {
        'forget-passwordogin-email-input': {
          required: 'The Email field is required',
          email: 'The Email field must be a valid email'
        }
      }
    }
  },
  mounted () {
    this.$validator.localize('en', {
      custom: this.errorMessages
    })
  },
  methods: {
    openModal () {
      if (this.$refs['forget-password-modal']) {
        this.$refs['forget-password-modal'].show()
      }
    },
    closeModal () {
      if (this.$refs['forget-password-modal']) {
        this.$refs['forget-password-modal'].hide()
      }
    },
    onSubmit (e) {
      e.preventDefault()
    },
    onReset () {

    },
    onModalHide () {
      // clear form
      this.forgotPasswordForm.email = ''
    },
    validateState (ref) {
      if (process.client) {
        if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
        ) {
          return !this.veeErrors.has(ref)
        }
      }
      return null
    },
    onResetPassword (e) {
      e.preventDefault()
      const vm = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          // pass!
          const loader = this.$loading.show(vm.$coopHelper.getLoadingOptions())
          vm.$store.dispatch('auth/FORGOT_PASSWORD', {
            email: this.forgotPasswordForm.email
          })
            .then((result) => {
              // show info
              /* vm.$bvToast.toast('Successfully Requested!', {
                title: 'Forgot password request',
                variant: 'success',
                solid: false
              }) */
              vm.closeModal()
              this.$bvModal.show('forget-password-sent-modal')
            })
            .catch((err) => {
              const message = vm.$coopHelper.getApiErrorMessage(err)
              vm.$bvModal.msgBoxOk(message, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                // okVariant: 'danger',
                hideHeader: true,
                modalClass: 'coop-modal -message-box',
                okTitle: 'CLOSE',
                centered: true
              })
                .catch((error) => { console.log(error) })
            })
            .finally(() => {
              loader.hide()
            })
        }
      })
    }
  }
}
</script>
